import { ReactElement } from 'react';
import { TextField } from '@ff-it/form';
import { CategoryField } from '../category/MediaCategoryField';
import { AllActivityTypesField } from 'components';

export function OutletOrServiceCategoryForm(): ReactElement {
  return (
    <div className="container px-0 ml-0">
      <div className="form-row">
        <TextField name="name" label="Name" className="col-md-6" required />
      </div>
      <div className="form-row">
        <AllActivityTypesField name="type" label="Type" placeholder="Any type" className="col-md-6" />
      </div>
      <div className="form-row">
        <CategoryField name="category" label="Category" className="col-md-6" help="Default category for products" />
      </div>
    </div>
  );
}
